const BackEndUrl = {
     //domain: "http://35.187.224.194:3001"
    //domain: "http://localhost:3001"
    domain: "https://ieg.sicl.lk:3001"
    //domain: "https://uat-ieg.sicl.lk:3001"
    
  };
  
  export default BackEndUrl;